function toFacebook(opts: { url: string; quote: string }) {
  const { url } = opts;
  const encodedUrl = encodeURIComponent(url);
  const encodedQuote = encodeURIComponent(opts.quote);
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedQuote}`;
  window.open(facebookUrl, '_blank');
}

function toLinkedIn(opts: { url: string; title: string; summary: string }) {
  const { url, title, summary } = opts;
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedSummary = encodeURIComponent(summary);
  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}&title=${encodedTitle}&summary=${encodedSummary}`;
  window.open(linkedInUrl, '_blank');
}

function toTwitter(opts: { url: string; tweet: string }) {
  const { url, tweet } = opts;
  const encodedUrl = encodeURIComponent(url);
  const encodedTweet = encodeURIComponent(tweet);
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTweet}`;
  window.open(twitterUrl, '_blank');
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    toFacebook,
    toLinkedIn,
    toTwitter,
  };
})();
